import { useEffect } from 'react'

import { TNullableString } from '@/config/types'

import { ApiService } from '@/api'

import { ISessionContext } from '../session'

function urlHasEmailCampaignCandidate() {
  return window.location.search.includes('ecc=') || window.location.search.includes('ltp_ecc=')
}

let confirmInProgress = false

function replaceState(emailCampaign?: TNullableString, ltpEmailCampaign?: TNullableString) {
  const currentUrl: URL = new URL(window.location.href)

  if (currentUrl.searchParams.get('ecc')) {
    currentUrl.searchParams.delete('ecc')
  }
  if (currentUrl.searchParams.get('ltp_ecc')) {
    currentUrl.searchParams.delete('ltp_ecc')
  }
  if (emailCampaign) {
    currentUrl.searchParams.set('utm_email_campaign', emailCampaign)
  }
  if (ltpEmailCampaign) {
    currentUrl.searchParams.set('utm_ltp_email_campaign', ltpEmailCampaign)
  }

  const hash = currentUrl.hash
  window.history.replaceState(
    window.history.state,
    '',
    currentUrl.pathname + currentUrl.search + hash
  )
}

export async function confirmEmailCampaign(sessionContext: ISessionContext): Promise<void> {
  const urlParams = new URLSearchParams(window.location.search)
  const emailCampaign = urlParams.get('ecc')
  const ltpEmailCampaign = urlParams.get('ltp_ecc')

  if ((!emailCampaign && !ltpEmailCampaign) || confirmInProgress) {
    return
  }

  try {
    confirmInProgress = true
    await ApiService.confirmEmailCampaign(
      window.config.PAGE_SET_ID,
      emailCampaign,
      ltpEmailCampaign,
      true
    )
    sessionContext.setEmailCampaign(emailCampaign, ltpEmailCampaign)
    replaceState(emailCampaign, ltpEmailCampaign)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.response) {
      replaceState()
    }
  }
}

type TListener = (event: Event) => void

function addListeners(onEventFn: TListener) {
  if (typeof window !== 'undefined') {
    document.addEventListener('mousedown', onEventFn)
    document.addEventListener('scroll', onEventFn)
    document.addEventListener('keydown', onEventFn)
    document.addEventListener('click', onEventFn)
  }
}

function removeListeners(onEventFn: TListener) {
  if (typeof window !== 'undefined') {
    document.removeEventListener('mousedown', onEventFn)
    document.removeEventListener('scroll', onEventFn)
    document.removeEventListener('keydown', onEventFn)
    document.removeEventListener('click', onEventFn)
  }
}

export function useEmailCampaignConfirmation(sessionContext: ISessionContext) {
  useEffect(() => {
    if (confirmInProgress || !urlHasEmailCampaignCandidate()) {
      return
    }

    const onTrigger = function () {
      if (confirmInProgress || !urlHasEmailCampaignCandidate()) {
        return
      }

      confirmEmailCampaign(sessionContext)
    }

    addListeners(onTrigger)

    return () => removeListeners(onTrigger)
  }, [sessionContext])
}
